import {observer} from 'mobx-react';
import RemoveModal from 'shared/components/modals/RemoveModal';

const RemoveDimensionModal = observer(({modalOpen, uiState}) => {
  return (
    <RemoveModal
      isOpen={modalOpen}
      onHide={() => uiState.closeRemoveDimensionModal()}
      header='time_tracking.dimensions.Remove Dimension?'
      subHeader='time_tracking.dimensions.Are you sure you want to remove this dimension?'
      body='time_tracking.dimensions.REMOVE_DIMENSION_DESCRIPTION'
      onConfirm={() => uiState.removeDimension()}
    />
  );
});

export default RemoveDimensionModal;
